import React, { FC } from 'react';

import classNames from 'classnames';

import { DATA_TEST_IDS } from '../../../consts';
import { TEXTS } from '../../../texts';
import PromoOptionsState from '../PromoOptionsState';
import type { PromoErrorStateProps } from './types';

import styles from './index.module.scss';

const PromoErrorState: FC<PromoErrorStateProps> = ({ isInline = false, onRetry }) => (
  <PromoOptionsState
    className={classNames({ [styles.inline]: isInline })}
    testId={DATA_TEST_IDS.AUDIO_REPORT_PROMOS_ERROR}
    role="alert">
    <span>{TEXTS.AUDIO_REPORT_PROMOS_ERROR}</span>
    <button
      type="button"
      className={styles.retry}
      data-testid={DATA_TEST_IDS.AUDIO_REPORT_PROMOS_RETRY}
      onClick={onRetry}>
      {TEXTS.AUDIO_REPORT_PROMOS_RETRY}
    </button>
  </PromoOptionsState>
);

export default PromoErrorState;
